module.exports = __webpack_public_path__ + "img/impressionen_terrasse.e49c4aad.jpg";